import type { RoomStorage, BroadcastChannel } from '../../types/infrastructure.types'
import type { GetChallengeConfigurationPreferenceArgs, SetChallengeConfigurationPreferenceArgs } from '../../schemas/action.schemas'
import type { ChallengeConfiguration } from '../../types/room.types'

/** Persists the preferred challenge source and game-challenge arrangement separately from game options. */
export function makeChallengeConfigurationPreference(container: { storage: RoomStorage; broadcastChannel: BroadcastChannel }) {
  const getChallengeConfigurationPreference = async (
    args: GetChallengeConfigurationPreferenceArgs,
  ): Promise<{ challengeConfiguration: ChallengeConfiguration | null }> => ({
    challengeConfiguration: container.storage.getState().challengeConfigurationPreferenceById?.[args.gameId] ?? null,
  })

  const setChallengeConfigurationPreference = async (
    args: SetChallengeConfigurationPreferenceArgs,
  ): Promise<{ success: boolean }> => {
    const state = container.storage.getState()
    container.storage.setState({
      ...state,
      challengeConfigurationPreferenceById: {
        ...state.challengeConfigurationPreferenceById,
        [args.gameId]: args.challengeConfiguration,
      },
    })
    container.broadcastChannel.broadcast({
      type: 'challengeConfigurationPreferenceChanged',
      data: args,
    })
    return { success: true }
  }

  return { getChallengeConfigurationPreference, setChallengeConfigurationPreference }
}
